import { createAction } from '@reduxjs/toolkit';

export const UPDATE_PAGE_NO = 'UPDATE_PAGE_NO';
export const UPDATE_SEARCH_INPUT = 'UPDATE_SEARCH_INPUT';
export const UPDATE_START_DATE = 'UPDATE_START_DATE';
export const UPDATE_END_DATE = 'UPDATE_END_DATE';
export const UPDATE_SORT_BY = 'UPDATE_SORT_BY';
export const UPDATE_SORT_ORDER = 'UPDATE_SORT_ORDER';
export const RESET_VALUES = 'RESET_VALUES';
export const RESET_FILTERS = 'RESET_FILTERS';
export const UPDATE_ROWS_PER_PAGE = 'UPDATE_ROWS_PER_PAGE';
export const UPDATE_TOTAL_COUNT = 'UPDATE_TOTAL_COUNT';
export const UPDATE_DISPLAY_ACTIVE = 'UPDATE_DISPLAY_ACTIVE';
export const UPDATE_FILTER_TYPES = 'UPDATE_FILTER_TYPES';
export const UPDATE_FILTER_TEMPLATES = 'UPDATE_FILTER_TEMPLATES';
export const UPDATE_FILTER_PRODCT_NAMES = 'UPDATE_FILTER_PRODCT_NAMES';
export const UPDATE_FILTER_PRODUCT_CATEGORIES =
  'UPDATE_FILTER_PRODUCT_CATEGORIES';
export const UPDATE_FILTER_EVENT_TYPE_CATEGORIES =
  'UPDATE_FILTER_EVENT_TYPE_CATEGORIES';
export const UPDATE_FILTER_OCCURRENCE_TYPES =
  'UPDATE_FILTER_OCCURRENCE_TYPES';
export const UPDATE_FILTER_MARKETING_TYPES =
  'UPDATE_FILTER_MARKETING_TYPES';
export const UPDATE_FILTER_TAGS = 'UPDATE_FILTER_TAGS';
export const CLEAR_TABLE_AND_TOOLBAR_STORE = 'CLEAR_TABLE_AND_TOOLBAR_STORE';
export const UPDATE_PAGINATED_FILTERS = 'UPDATE_PAGINATED_FILTERS';
export const UPDATE_FILTER_PAGINATED_TEMPLATES = 'UPDATE_FILTER_PAGINATED_TEMPLATES';
export const UPDATE_FILTER_PAGINATED_CAMPAIGNS = 'UPDATE_FILTER_PAGINATED_CAMPAIGNS';
export const UPDATE_FILTER_EVENT_IDENTIFIER_VALUES = 'UPDATE_FILTER_EVENT_IDENTIFIER_VALUES';
export const UPDATE_FILTER_SURVEY_QUESTIONS = 'UPDATE_FILTER_SURVEY_QUESTIONS';
export const UPDATE_FILTER_GUEST_INFO_VALUES = 'UPDATE_FILTER_GUEST_INFO_VALUES';
export const UPDATE_FILTER_CONTACT_INFO_VALUES = 'UPDATE_FILTER_CONTACT_INFO_VALUES';
export const UPDATE_FILTER_CONSENT_VALUES = 'UPDATE_FILTER_CONSENT_VALUES';

export const updatePageNo = createAction(UPDATE_PAGE_NO);
export const updateSearchInput = createAction(UPDATE_SEARCH_INPUT);
export const updateStartDate = createAction(UPDATE_START_DATE);
export const updateEndDate = createAction(UPDATE_END_DATE);
export const updateSortBy = createAction(UPDATE_SORT_BY);
export const updateSortOrder = createAction(UPDATE_SORT_ORDER);
export const resetValues = createAction(RESET_VALUES);
export const resetFilters = createAction(RESET_FILTERS);
export const updateRowsPerPage = createAction(UPDATE_ROWS_PER_PAGE);
export const updateTotalCount = createAction(UPDATE_TOTAL_COUNT);
export const updateDisplayActive = createAction(UPDATE_DISPLAY_ACTIVE);
export const updateFilterTypes = createAction(UPDATE_FILTER_TYPES);
export const updateFilterTemplates = createAction(UPDATE_FILTER_TEMPLATES);
export const updateFilterProductNames = createAction(
  UPDATE_FILTER_PRODCT_NAMES
);
export const updateFilterProductCategories = createAction(
  UPDATE_FILTER_PRODUCT_CATEGORIES
);
export const updateFilterEventTypeCategories = createAction(
  UPDATE_FILTER_EVENT_TYPE_CATEGORIES
);
export const updateFilterOccurrenceTypes = createAction(
  UPDATE_FILTER_OCCURRENCE_TYPES
);
export const updateFilterMarketingTypes = createAction(
  UPDATE_FILTER_MARKETING_TYPES
);
export const updateFilterTags = createAction(UPDATE_FILTER_TAGS);
export const clearTableAndToolbarStore = createAction(CLEAR_TABLE_AND_TOOLBAR_STORE);
export const updatePaginatedFilters = createAction(UPDATE_PAGINATED_FILTERS);
export const updateFilterPaginatedTemplates = createAction(UPDATE_FILTER_PAGINATED_TEMPLATES);
export const updateFilterPaginatedCampaigns = createAction(UPDATE_FILTER_PAGINATED_CAMPAIGNS);
export const updateFilterEventIdentifierValues = createAction(UPDATE_FILTER_EVENT_IDENTIFIER_VALUES);
export const updateFilterSurveyQuestions = createAction(UPDATE_FILTER_SURVEY_QUESTIONS);
export const updateFilterGuestInfoValues = createAction(UPDATE_FILTER_GUEST_INFO_VALUES);
export const updateFilterContactInfoValues = createAction(UPDATE_FILTER_CONTACT_INFO_VALUES);
export const updateFilterConsentValues = createAction(UPDATE_FILTER_CONSENT_VALUES);